export default "__VITE_ASSET__CthmjMwy__"